import { makeStyles, shorthands } from '@fluentui/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { customPalette } from '../../theme';
import FilterGroup from '../common/FilterGroup';

export interface IFilterBarProps {
    filterGroupItems: React.ReactNode[];
    isFiltered: boolean;
    clearAllFilters: () => void;
    compareButton?: JSX.Element;
}

const useStyles = makeStyles({
    card: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 'auto',
        maxWidth: '100%',
        height: 'auto',
        backgroundColor: '#fff',
        paddingTop: '12px',
        paddingRight: '16px',
        paddingBottom: '12px',
        paddingLeft: '16px',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        ...shorthands.border('1px', 'solid', customPalette.greyD1D3D4),
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        width: '100%',
    },
    buttonGap: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '5px',
    },
});

const ReportToolbar: React.FC<IFilterBarProps> = (props: IFilterBarProps) => {
    const { isFiltered, clearAllFilters } = props;
    const { t } = useTranslation();
    const styles = useStyles();

    return (
        <div className={styles.card}>
            <div className={styles.buttonsContainer}>
                <FilterGroup isFiltered={isFiltered} clearAllFiltersLabel={t('filterBarClearAllFilters')} clearAllFilters={clearAllFilters}>
                    <div className={styles.buttonGap}>
                        {props.filterGroupItems.map((item, index) => (
                            <React.Fragment key={`report-toolbar-filters-${index}`}>{item}</React.Fragment>
                        ))}
                        {props.compareButton}
                    </div>
                </FilterGroup>
            </div>
        </div>
    );
};

export default ReportToolbar;
